import Vue from 'vue'

const state = {
  customers: {}
}

const mutations = {
  FETCH (state, customers) {
    state.customers = customers
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('customers')
      .then(response => {
        commit('FETCH', response.data)
      })
  }
}

const getters = {
  getCustomerById: state => customerID => {
    return state.customers[customerID]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
